import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'cityads-v3/types/reducer';

export function useHeaderBarItemData<DataType>(type: string): DataType | null {
  const barItems = useSelector((state: RootState) => state.header.bar);

  const barItem = useMemo(() => {
    return barItems.filter(item => item.type === type)[0];
  }, [barItems, type]);

  return barItem ? barItem.data as DataType : null;
}
